import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import useReportQueryParams from '../../../../hooks/use-report-query-params';
import ProgressForCharactersChartView from './ProgressForCharactersChartView';
import ProgressForCharactersTableView from './ProgressForCharactersTableView';
import ProgressForStudentsTableView from './ProgressForStudentsTableView';
import ProgressForStudentsChartView from './ProgressForStudentsChartView';
import { ModuleType, ReportDisplayBy, ReportView } from '../../../../types';

const ClassroomErrorAnalysisCards: React.FC = () => {
  const [{ viewAs, displayBy }] = useReportQueryParams();
  const { t } = useTranslation('Reports');

  const REPORT_VIEW_MAP: { [key in ReportView]?: any } = {
    [ReportView.CHART]: {
      [ReportDisplayBy.CHARACTERS]: ProgressForCharactersChartView,
      [ReportDisplayBy.STUDENTS]: ProgressForStudentsChartView
    },
    [ReportView.TABLE]: {
      [ReportDisplayBy.CHARACTERS]: ProgressForCharactersTableView,
      [ReportDisplayBy.STUDENTS]: ProgressForStudentsTableView
    }
  };

  const ProgressComponent = REPORT_VIEW_MAP[viewAs][displayBy ?? ReportDisplayBy.STUDENTS];

  return (
    <section>
      <Typography variant="h3">{t('Progress')}</Typography>
      <ProgressComponent module={ModuleType.CAPITALS} />
      <ProgressComponent module={ModuleType.LOWERCASE} />
      <ProgressComponent module={ModuleType.NUMBERS} />
    </section>
  );
};

export default React.memo(ClassroomErrorAnalysisCards);
